<div class="privilege" *ngIf="!hide">
    <!-- <div class="privilege" *ngIf="true"> -->
    <div class="get-coupon" [routerLink]="['/user-center/customer-coupon/receive-coupon']">
        <img class="new-privilege" src="/assets/img/home_img_new_coupon.png" alt="">
        <p class="btn"></p>
        <p class="close" (click)="couponClose($event)"></p>
    </div>
</div>